export default (string = ``) => {
  const sanitizedInput = string?.replace(/<+/g, '<').replace(/>+/g, '>') || '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedInput, 'text/html');
  return doc.body.textContent?.replace(/\u00A0/g, ' ').trim() || '';
};
